import { api_GET, api_POST, api_PUT, api_DELETE } from "./_api.js";

const tipoRequerimento_api = {
    getList: (origem) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`TiposRequerimento/getlist/${origem ? origem : ""}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getListEtapas: (tipoRequerimentoId) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`TiposRequerimento/getlistetapas/${tipoRequerimentoId}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET("TiposRequerimento/getitem/" + id)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetTipoRequerimentoEtapas: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET("TiposRequerimento/GetTipoRequerimentoEtapas/" + id)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetTipoRequerimentoEtapa: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET("TiposRequerimento/GetTipoRequerimentoEtapa/" + id)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetTipoRequerimentoEtapasAcoes: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET("TiposRequerimento/GetTipoRequerimentoEtapasAcoes/" + id)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetTipoRequerimentEtapaAcao: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET("TiposRequerimento/GetTipoRequerimentEtapaAcao/" + id)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getListDocumentos: (id, requerimento_id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET("TiposRequerimento/getlistdocumentos/" + id + `/${requerimento_id ? requerimento_id : ""}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    postTipoRequerimento: (tipoRequerimento) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("TiposRequerimento/PostTipoRequerimento/", tipoRequerimento)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    putTipoRequerimento: (tipoRequerimento) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT("TiposRequerimento/PutTipoRequerimento/", tipoRequerimento)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    postTipoRequerimentoEtapa: (tipoRequerimentoEtapa) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("TiposRequerimento/PostTipoRequerimentoEtapa/", tipoRequerimentoEtapa)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    putTipoRequerimentoEtapa: (tipoRequerimentoEtapa) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT("TiposRequerimento/PutTipoRequerimentoEtapa/", tipoRequerimentoEtapa)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    postTipoRequerimentoEtapaAcao: (tipoRequerimentoEtapaAcao) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("TiposRequerimento/PostTipoRequerimentoEtapaAcao/", tipoRequerimentoEtapaAcao)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    putTipoRequerimentoEtapaAcao: (tipoRequerimentoEtapaAcao) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT("TiposRequerimento/PutTipoRequerimentoEtapaAcao/", tipoRequerimentoEtapaAcao)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    deleteTipoRequerimentoEtapaAcao: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_DELETE("TiposRequerimento/DeleteTipoRequerimentoEtapaAcao/" + id)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    deleteTipoRequerimentoEtapa: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_DELETE("TiposRequerimento/DeleteTipoRequerimentoEtapa/" + id)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}

export default tipoRequerimento_api;
